export function isRecurringEventData(eventData = {}) {
  return String(eventData?.type || '').toLowerCase() === 'recurring'
    || (Array.isArray(eventData?.recurrence?.byDay) && eventData.recurrence.byDay.length > 0);
}

export function resolveEventCommentOccurrenceId(eventData, occurrenceId) {
  if (!occurrenceId) return null;
  return isRecurringEventData(eventData) ? occurrenceId : null;
}
